module.exports = __webpack_public_path__ + "img/build_it.da754159.svg";